import React from "react";
import { FaFacebook, FaInstagram, FaEnvelope } from "react-icons/fa"; // Icone per social e mail
import logo from "../../assets/logo bianco.png";
import "./Footer.css";

const Footer = () => {
  const handleScroll = (e, target) => {
    e.preventDefault();
    const section = document.querySelector(target);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Lato sinistro: Logo e scritta */}
        <div className="footer-logo">
          <img
            src={logo}
            alt="Logo Tenute Colonico"
            className="footer-logo-img"
          />
          {/* <p>Tenute Colonico srl</p> */}
        </div>

        {/* Lato centrale: Icone social e mail */}
        <div className="footer-social">
          {/*   <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="social-icon">
            <FaFacebook size={30} />
          </a> */}
          <a
            href="https://instagram.com/tenutecolonico"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaInstagram size={30} />
          </a>
          <a href="mailto:info@tenutecolonico.com" className="social-icon">
            <FaEnvelope size={30} />
          </a>
        </div>

        {/* Lato destro: Link chi siamo, nostro prodotto, contatti */}
        <div className="footer-links">
          <ul>
            <li>
              {" "}
              <a
                href="#identità"
                onClick={(e) => handleScroll(e, "#identità")}
                className="hover:text-gray-600 transition-colors"
              >
                Identità
              </a>
            </li>
            <li>
              {" "}
              <a
                href="#linee"
                onClick={(e) => handleScroll(e, "#linee")}
                className="hover:text-gray-600 transition-colors"
              >
                Linee
              </a>
            </li>
            <li>
              {" "}
              <a
                href="#luoghi"
                onClick={(e) => handleScroll(e, "#luoghi")}
                className="hover:text-gray-600 transition-colors"
              >
                Luoghi
              </a>
            </li>
            <li>
              {" "}
              <a
                href="#volti"
                onClick={(e) => handleScroll(e, "#volti")}
                className="hover:text-gray-600 transition-colors"
              >
                Volti
              </a>
            </li>
            <li>
              <a
                href="#contatti"
                onClick={(e) => handleScroll(e, "#contatti")}
                className="hover:text-gray-600 transition-colors"
              >
                Contatti
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          &copy; 2025 Tenute Colonico srl. All rights reserved. || P.IVA
          02048630665
        </p>
      </div>
    </footer>
  );
};

export default Footer;
